<template>
  <div>
    <material-card>
      <v-toolbar slot="header" color="primary">
        <v-toolbar-title>Votes</v-toolbar-title>
      </v-toolbar>
      <v-data-table
        :headers="votes.headers"
        :items="displayedVotes"
        dense
        class="elevation-1"
        :items-per-page="10"
      >
      </v-data-table>
    </material-card>
  </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
  props: {
    campaignVotes: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      votes: {
        headers: [
          {
            text: 'Merchant',
            value: 'merchant_name',
            sortable: true
          },
          {
            text: 'Total',
            value: 'votes',
            sortable: true
          }
        ],
        options: {},
        data: [],
        total: 0,
        loading: true,
        totals: {}
      },
      qrcodesTableOptions: {}
    }
  },
  computed: {
    ...mapState({
      auth: 'auth',
      alerts: (state) => state.alert.snackbars
    }),
    loggedIn () {
      return this.auth.loggedIn
    },
    loggedUser () {
      return this.auth.user || null
    },
    displayedVotes () {
      let unique = [
        ...new Set(this.campaignVotes.map((item) => item.merchant_name))
      ]
      console.log('Unique', unique)
      const voteData = unique.map((merchant) => {
        const number = this.campaignVotes.filter((vote) => {
          return vote.merchant_name === merchant
        }).length
        return {
          merchant_name: merchant,
          votes: number
        }
      })
      return voteData
    }
  }
}
</script>
